const DialogComponent = require('../components/dialog');

/**
 * @typedef {Object} CustomDialogPluginSettings
 * @property {boolean} open - open dialog
 * @property {Function} interruptClosing - used to interrupt the closing of the dialog and provide a custom closing logic
 */

/**
 * @typedef {Object} DialogPluginSettings
 * @property {string} id - dialog id
 * @property {HTMLElement} dialog - dialog element
 * @property {CustomDialogPluginSettings} dialogOption - custom settings
 */

/**
 * @module DialogPlugin
 * @exports DialogPlugin
 * @param {DialogPluginSettings} dialogOption - dialog settings
 * @returns {Function} - Set up the dialog
 */
function DialogPlugin(dialogOption) {
    return this.each((i, dialog) => {
        const $dialog = $(dialog);
        const defaultOptions = DialogPlugin.defaultOptions($dialog);
        const options = Object.assign({}, defaultOptions, dialogOption);

        if ($dialog.data('dialog')) {
            $dialog.data('dialog').init(options);
            return;
        }

        $dialog.data('dialog', new DialogComponent(dialog, options));
    });
}

DialogPlugin.defaultOptions = ($dialog) => {
    const { size, position, desktopSize, desktopPosition, theme, open } = $dialog.data();
    const defaultOptions = {
        id: $dialog.attr('id'),
        size,
        position,
        desktop: {
            size: desktopSize,
            position: desktopPosition
        },
        theme,
        open
    };

    return defaultOptions;
};

module.exports = DialogPlugin;
